import React, { useState } from "react"
import { useHistory } from "react-router"
import FollowUpVisit from "../../../../components/FollowUpVisit"
import SummaryView from "../../../../components/SummaryView"
import Toast from "../../../../components/Toast"

import { IPatient } from "../../../../core/services/models/Patient"
import "./HomeCare.scss"

const HomeCare: React.FunctionComponent<any> = (
  {
    patientInfo,
    recordDetails,
    appointmentDetails,
    isReadOnly,
    staffType,
    smartSummaryDetails,
    fetchSmartSummary
  }
) => {
  const history = useHistory()
  const tabSection: string[] = ["Smart Summary", "Consultant Notes"]
  const [patientDetail, updatePatientDetail] =
    React.useState<IPatient>(patientInfo)
  const [selectedTab, setSelectedTab] = useState("Smart Summary")
  const [resFollowUpData, setResFollowUpData] = useState<any>({})
  const [isFollowUpData, setIsFollowUpData] = useState(false)

  const centerId = appointmentDetails?.centerId
  const consultantId = appointmentDetails?.consultantId
  const appointmentId = appointmentDetails?.id
  const appointmentType = appointmentDetails?.appointmentType
  const recordId = recordDetails?.id
  const patientId = appointmentDetails?.patientId

  return (
    <div className="Home-care-container">
      <div className="patient-diagnosis">
        <div className="patient-smart-summary">
          {
            resFollowUpData?.id && isFollowUpData ? (
              <Toast
                textMessage={` Follow Up Data added Successfully`}
                type="success"
                onCloseText={"Close"}
                onClickText={"Appointments"}
                onClose={() => setIsFollowUpData(false)}
                onClick={() => history.push("/calendar")}></Toast>
            ) : (
              ""
            )
          }
          <div className="tab-wrapper">
            {tabSection.map((tabname) => (
              <div
                className={`tab ${selectedTab === tabname ? "active" : ""}`}
                onClick={() => {
                  setSelectedTab(tabname)
                  if (tabname === "Smart Summary") {
                    fetchSmartSummary()
                  }
                }}>
                {tabname}
              </div>
            ))}
          </div>
          <div className="content-wrapper">
            {selectedTab === "Smart Summary" ? (
              <SummaryView
                patientDetail={patientInfo}
                smartSummaryDetails={smartSummaryDetails}
              />
            ) : selectedTab === "Consultant Notes" ? (
              <FollowUpVisit
                isEditable={true}
                setResFollowUpData={setResFollowUpData}
                setIsFollowUpData={setIsFollowUpData}
                recordDetails={recordDetails}
                appointmentDetails={appointmentDetails}
                patientDetail={patientInfo}
                isReadOnly={isReadOnly}
                staffType={staffType}
                smartSummaryData={smartSummaryDetails}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeCare
